
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, InfoIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

const CTA = () => {
  return (
    <section className="py-20 bg-lawyer-primary text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold font-display mb-6">
          Transforme sua produtividade jurídica
        </h2>
        <p className="text-xl text-gray-200 max-w-2xl mx-auto mb-10">
          Junte-se a centenas de advogados que já otimizam seu trabalho com IA. Acesse agora nossa biblioteca completa de prompts totalmente grátis.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button 
            asChild 
            size="lg" 
            className="bg-lawyer-secondary hover:bg-lawyer-gold text-lawyer-dark font-medium transition-colors"
          >
            <Link to="/auth/register" className="flex items-center">
              Começar Agora
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
          <Button 
            asChild 
            size="lg" 
            variant="outline" 
            className="bg-transparent border border-white hover:bg-white/10 text-white"
          >
            <Link to="/how-to-use" className="flex items-center">
              <InfoIcon className="mr-2 h-5 w-5" />
              Saiba Mais
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
